module.exports = __webpack_public_path__ + "static/media/bz.8016a024.svg";